import { render, staticRenderFns } from "./SetUpBusinessSetting.vue?vue&type=template&id=e80d0f66&"
import script from "./SetUpBusinessSetting.vue?vue&type=script&lang=js&"
export * from "./SetUpBusinessSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports